module.exports = __webpack_public_path__ + "img/clipboard.6f71272b.svg";